export const globalConfig = {
    domainName: 'data2go',
    dataSize: 'GB',
    libraries: ['places'],
    allowPhoneNumberLength: 16,
    pageCount:20,
    defaultCurrency: '$',
    brandCurrencyMap: {
        'data2go': '$',
        'esimple': '€',
        'esimlinks': '$',
        'gopamwe': '$',
        'esimcrew': '$',
        'data2go-iot': '$',
        'pinoy': '$',
        'pinoy-corporate': '$',
        'orzo': '$',
        'orzo-corporate': '$',
      },
    paymentDefaultCurrency: '$',
    paymentDefaultCountry: 'US',
    paymentDefaultLabel: 'eSIM Purchase',
    supportEmail: 'support@data2go.mobi',
    contactEmail: 'contact@data2go.mobi',
    salesEmail: 'sales@data2go.mobi',
    phoneNumber:"+31 651683106",
    callUsPhoneNumber:"+44 1223 926858",
    allowNameLength: 20,
    toastDisplayTime: 10000,
    errorToastDisplayTime:100000,
    deviceInfo: "website",
    isEsimCompatible: false,
    catalogDataAmountperGB: 1000,
    notificationCount:20,
    languageObjectLength: 3,
}

export const envConfig = process.env

export const getCurrencySymbol = () => {
    const brand = process.env.REACT_APP_NAME;
    return globalConfig.brandCurrencyMap[brand] || globalConfig.defaultCurrency;
};  

export const responsiveOptions = [
    {
        breakpoint: "1199px",
        numVisible: 3,
        numScroll: 1
    },
    {
        breakpoint: "991px",
        numVisible: 2,
        numScroll: 1
    },
    {
        breakpoint: "767px",
        numVisible: 1,
        numScroll: 1
    }
];
